// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Translations
import { CARD, IBAN } from '../translations/financial-data-payment-method.translations';
// Types
import { FinancialDataPaymentMethodComponentType } from '../types/financial-data-payment-method.component.type';

const getFormattedIban = (iban: string): string => `${iban.slice(0, 2)} ...${iban.slice(-4)}`;

const getPaymentMethodTranslation = (
  detail: FinancialDataPaymentMethodComponentType['detail']
): React.ReactElement => {
  const selectedIban = detail?.accounts?.find(account => account.selected);
  const id = selectedIban ? IBAN : CARD;
  const values = selectedIban && { iban: getFormattedIban(selectedIban.iban) };

  return <FormattedMessage {...{ id, values }} />;
};

export { getPaymentMethodTranslation, getFormattedIban };
